//import { dataActions } from './ui-slice';
import { dataActions } from './data-slice';

import { fetchConToken } from '../helpers/fetch';
import Swal from 'sweetalert2';


//Deberian leerse desde auth, y cargar en redux store
let lat = -2.068697;
let long =-79.83206;

export const fetchWeather = (lang) => {
  return async (dispatch) => {
    try {
        const resp = await fetchConToken( `weather?lat=${lat}&lon=${long}&lang=${lang}` )
         // console.log(resp);
        if (!resp.ok) {
          throw new Error('Weather data fetch');
        }
        const body = await resp.json();
          
        dispatch( dataActions.weatherData({
            city: body.city[0].name,
            weather: body.data,
        }) )
           
    }
    catch (error) {
      Swal.fire('Error 0xC002', "Weather data fetch", 'error');
    }
        
  }
} 


export const fetchPredictions = (type) => {
  return async (dispatch) => {
    try {
        const resp = await fetchConToken( `prediction?type=${type}` )
         // console.log(resp);
        if (!resp.ok) {
          throw new Error('Error al cargar Predicciones');
        }
        const body = await resp.json();
          
        dispatch( dataActions.PredictionsData({
            prediction: body.predict,
        }) )
           
    }
    catch (error) {
      Swal.fire('Error generando predicción 0xP03', "Resultados no disponibles", 'error');
    }
        
  }
} 

export const setDateHistoricos = (value) => {
  return async (dispatch) => {
    try {
        let startDate = "-12h";
        let endDate = "now()";
        if (value[0] && value[0]!=null) {
          startDate = value[0]._d.toISOString();
          //console.log("date start GMTstring:", value[0]._d.toGMTString());
          //console.log("date start UTCstring:", value[0]._d.toUTCString());
          console.log("date start ISOstring:", value[0]._d.toISOString());
        }
        if (value[1] && value[1]!=null) {
          endDate = value[1]._d.toISOString();
          console.log("date end:", value[1]._d.toISOString());
        }
        
        
        dispatch(dataActions.filtrosDateHistoricos({
          startDate: startDate,
          endDate: endDate,
        }))
           
    }
    catch (error) {
      Swal.fire('Error aplicando filtros 0xSDH001', "Error al aplicar filtros", 'error');
    }
        
  }
} 

